<template>
  <v-app>
    <v-toolbar class="elevation-1">
      <h4>Visitor - {{ $route.params.id === 0 ? "Create" : "Edit" }}</h4>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-container grid-list-xl fluid>
      <breadcrumbs
        :routelinks="[
          { text: 'Visitor', href: '#/visitors' },
          {
            text: $route.params.id === 0 ? 'Create' : 'Edit',
            href: '#',
            disabled: true
          }
        ]"
      />
      <v-layout row wrap>
        <v-flex>
          <v-tabs
            background-color="transparent"
            grow
            v-model="tab"
            class="elevation-1"
          >
            <v-tab>Info</v-tab>
            <v-tab>Image</v-tab>
            <v-tabs-items v-model="tab">
              <v-tab-item>
                <v-card class="pa-3" flat color="basil">
                  <submit-form />
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card class="pa-3" flat color="basil">
                  <submit-image />
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
import Breadcrumbs from "@/components/Breadcrumbs";
import SubmitImage from "@/components/vistors/SubmitImage";
import SubmitForm from "@/components/vistors/SubmitForm";
export default {
  components: {
    Breadcrumbs,
    SubmitImage,
    SubmitForm
  },
  data() {
    return {
      isVisible: 0
    };
  },
  computed: {},
  watch: {},
  methods: {
    listChanged: function(index) {
      this.isVisible = index;
    }
  }
};
</script>
